export default __webpack_public_path__ + "947162cbfa90fae4aa793107b8c5a02e.jpg";